<template>
    <div class="login">
        <div class="title">
            <img src="@/assets/title2.png" style="max-width: 600px; height: auto;" alt="">
            <el-card shadow="always" class="login-card">
                <el-form label-position="left" status-icon>
                    <el-form-item label="教工号">
                        <el-input placeholder="请输入6位教工号" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                        <el-input show-password placeholder="请填写密码" v-model="form.password"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button style="width: 100%; margin-top: 20px;" type="primary" @click="goHome">登录</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import { userRegister, userLogin } from '@/utils/baaSApi'
import md5 from "js-md5";
export default {
    data() {
        return {
            form: {
                name: '',
                password: ''
            }
        }
    },
    computed: {},
    watch: {},
    methods: {
        async goHome() {
            var name = await userLogin(`cl${this.form.name}`, md5(this.form.password))
            if (name.code == 200) {
                this.$router.replace("/home");
            } else {
                this.$message.error(name.data);
            }

        }
    }
}
</script>
<style lang="css" scoped>
.login {
    display: flex;
    align-items: center;
    justify-content: end;
    width: 100%;
    height: 100vh;
    background-image: url('/src/assets/banner.png');
    /* 替换为你的图片路径 */
    background-size: cover;
    /* 背景图片按填充方式适应 */
    background-position: center;
    /* 居中显示背景图片 */
    background-repeat: no-repeat;
    /* 防止背景图片重复 */
}

.login-card {
    width: 370px;
    height: 350px;
    margin-left: 165px;

}

.title {
    width: 750px;
    text-align: center;
}
</style>